import React from 'react';
import { Redirect } from "react-router-dom";

import dayjs from 'dayjs';

import Header from "../../components/Header";
import FavoriteButton from "../../components/FavoriteButton";
import Form from "../../components/brews/Form";

import defaultBrewState from "../../static/defaultBrewState.json";

import GlobalData from '../../context/globaldata';

class Brew extends React.Component {
  static contextType = GlobalData;

  constructor(props) {
    super(props);
    this.notesContainer = React.createRef();
    this.state = {
      ...defaultBrewState,
      toBrew: false,
      overflowVisible: false,
      hideUnused: false,
      saving: false,
      notesVisible: false,
      actionsVisible: false
    };

    this.saveBrew = this.debounce(this.saveBrew.bind(this), 1000);
  };

  debounce(func, wait) {
    let timeout;
    return function() {
      const context = this;
      const args = arguments;
      const later = function() {
        timeout = null;
        func.apply(context, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  handleChange = (event, actionMeta) => {
    const target = event ? event.target : false;
    const key = target ? target.name : actionMeta.name || '';
    const value = target ? target.type === 'checkbox' ? target.checked : target.value : event;

    this.saveBrewState(key, value);
  };

  saveBrew() {
    this.setState({
      saving: true
    }, () => {
      if(this.state.brew.name) {
        this.currentDoc.set({
          ...this.state.brew,
          user: this.context.currentUser.uid
        }).then(() => {
          debugger
          this.context.addNotification('Brew added', 'Your new brew has been added', 'success', 'right', 'bottom-right');
          this.context.updateBrewAmount();
          this.setState({
            saving: false,
            toBrew: true
          });
        })
      } else {
        this.setState({
          saving: false
        });
        this.context.addNotification('Error', "You didn't fill in all required fields", 'danger', 'right', 'bottom-right');
      }

    });
  };

  saveBrewState = (key, value) => {
    this.setState({
      brew: {
        ...this.state.brew,
        [key]: value
      }
    })
  };

  updateRating = (rating) => {
    this.saveBrewState('rating', rating);
  };

  updateNotes = (notes) => {
    this.setState({
      brew: {
        ...this.state.brew,
        notes: notes
      }
    });
  };

  submitForm = (event) => {
    event.preventDefault();
    this.saveBrew();
  };

  componentDidMount() {
    this.setState({
      brew: {
        ...this.state.brew,
        user: this.context.currentUser.uid,
        roast_date: dayjs().format('YYYY-MM-DD'),
        opening_date: dayjs().format('YYYY-MM-DD'),
        brew_date: dayjs().format('YYYY-MM-DD'),
        advancedChart: this.context.userSettings.prefers_advanced_flavours
      }
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.params.brewId !== prevProps.params.brewId) {
      this.getBrew(this.props.params.brewId);
    }
  };

  render() {
    if(!this.currentDoc) {
      this.currentDoc = this.context.db.collection('brews').doc();
    }

    if(this.state.toBrew === true) {
      return <Redirect to={ `/brews/${ this.currentDoc.id }` } />
    }

    return (
      <section className="brew brew--single is-visible">

        <Header
          className="header--brew"
          title={ this.state.brew.name ? this.state.brew.name : 'Add brew' }
        >
          <div className="header__actions">
            <button className={ `button button--primary ${ this.state.saving ? 'is-loading' : '' }` } onClick={ this.saveBrew }>
              <i className="material-icons">add</i>
              <span>Add brew</span>
            </button>
            <FavoriteButton
              property={ this.state.brew.favorite }
              callback={ () => this.saveBrewState('favorite', !this.state.brew.favorite) }
            />
          </div>
        </Header>

        <Form
          brew={ this.state.brew }
          handleChange={ this.handleChange }
          updateNotes={ this.updateNotes }
          saveBrewState={ this.saveBrewState }
          updateRating={ this.updateRating }
          readOnlyMode={ this.context.userLimitReached }
          submitForm={ this.submitForm }
        />

      </section>
    );
  }
}

export default Brew;
